import styled from "styled-components";

export const ActionsList = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 1rem;
`;

export const ModalReasonsCointainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;
